import type { RuleResults } from '@interstate/components/Validation';
import type { CustomInterstateValidationRule } from '@makemydeal/dr-dash-components';

export const validateRules = (
    value: number | string | undefined,
    rules: CustomInterstateValidationRule[],
    suppressAlerts: boolean
): RuleResults => {
    const ruleResults = rules.map((rule) => rule(value));
    const firstErrorResult = ruleResults.find((ruleResult) => !ruleResult.isValid);
    const isValid = firstErrorResult === undefined;

    if (isValid || suppressAlerts) {
        return {
            validationState: { isValid: true, type: 'success' },
            triggered: false
        };
    }

    return {
        validationState: { isValid: false, message: firstErrorResult.errorMessage, type: 'error' },
        triggered: true
    };
};
